module.exports = __webpack_public_path__ + "img/business_15.c9e942cb.jpg";